export default "__VITE_ASSET__DCWlbO63__"